import {
    AccordionSummary,
    Breadcrumbs,
    Button,
    Container,
    Grid,
    Link,
    Paper,
    Typography,
    useMediaQuery
} from '@mui/material';
import MuiAccordion from '@mui/material/Accordion';
import { styled } from '@mui/material/styles';
import { IconArrowLeft } from '@tabler/icons';
import { useState } from "react";
import { useHistory } from "react-router-dom";
import './FAQs.css';
import MSIPage from './pages/MSIPage'
import IDPPage from './pages/IDPPage'
import WHTPage from './pages/WHTPage'
import GeneralPage from './pages/GeneralPage'
import SelectMenu from './menuOptions'

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    '&:not(:last-child)': {
        borderBottom: '1px gray solid',
    },
    '&.Mui-expanded &:not(:last-child)': {
        borderBottom: '1px #0065bd solid',
    },
    '.MuiAccordionSummary-root': {
        backgroundColor: '#fff',
        color: 'unset',
        fontFamily: 'var(--font-family-ptsans-bold)',
        fontSize: 'var(--font-size-l)',
    },
    '.Mui-expanded': {
        color: '#0065bd',
        fontFamily: 'var(--font-family-ptsans-bold)',
        fontSize: 'var(--font-size-l)',
    },
    '.MuiListItem-root': {
        padding: '6px 24px',
        fontFamily: 'var(--font-family-ptsans-regular)',
        fontSize: 'var(--font-size-l)',
    },
    '.MuiAccordionDetails-root': {
        paddingTop: '0'
    }
}));

export default function FAQs() {
    const history = useHistory();
    const [, setSearchstring] = useState('');
    const [searchwithin, setSearchwithin] = useState('');
    const [active, setActive] = useState('general');
    const handleClickMenu = (event) => {
        setActive(event.target.value)
        // alert(event.target.value);
      };
    const menuitem = [{key: "general", text: "General"}, {key: "idp", text: "Industry Digital Plan (IDP)"}, {key: "wht", text: "Withholding Tax (WHT) Exemption"}, {key:"msi", text: "Maritime Sector Incentive (MSI)"}]
    return (<>
    {/* <Helmet>
    <title>FAQ - MPA</title>
    <meta name="description" content="MPA Website" />
    </Helmet> */}
        <div className='FAQs'>
            <div className="exploreschemes">
                <div className="scheme-background">
                    <div className="backbanner" style={{ height: '310px' }} />
                    <Container>
                        <br />
                        <Button onClick={() => history.push('/Home')}
                            className='nav-back-btn'>
                            <IconArrowLeft color='#666' aria-label="back to home" />
                        </Button>
                        <Breadcrumbs sx={{ display: 'inline-block', verticalAlign: 'middle' }} aria-label="breadcrumb">
                            <Link underline='hover' sx={{ cursor: 'pointer' }}
                                onClick={() => history.push('/Home')}
                                mx={1}
                                className='active-link font-bold-scarpa-flow-12px'>
                                Home
                            </Link>
                            <Link underline='none'
                                mx={1} className='disabled-link font-bold-scarpa-flow-12px'>
                                FAQS
                            </Link>
                        </Breadcrumbs>
                        <br />
                        <br />
                        <Typography variant='h2' component='h1'>FAQS</Typography>
                        <Typography fontSize={'22px !important'} className='font-normal-mine-shaft-18px' my={2}>
                            How can we help you?
                        </Typography>


                        <div className='mobilefaq' style={{display: useMediaQuery('(max-width: 900px)') ? "" : "none"}}>
                        <br />
                            <Typography variant='h4' component='h2'>Categories</Typography>
                            <SelectMenu handleClickMenu={handleClickMenu} active={active} menuitem={menuitem} />
                        </div>

                        <Paper elevation={0} sx={{ position: 'relative', mt: 6, mb: 6, px: 8, py: 2, border: '1px solid #EAECF0', borderRadius: 2 }}>

                            <Grid container mt={0} mb={5} spacing={6}>
                                <Grid item xs={useMediaQuery('(min-width: 900px)') ? 3 : 9} style={{display: useMediaQuery('(min-width: 900px)') ? "" : "none"}}>
                                    <Typography variant="h3" component="h2">Categories</Typography>
                                    <br />

                                    {/* There is a change of queue for General (last) & MSI (first) */}
                                    <Accordion defaultExpanded={true}>
                                        {/* <AccordionSummary expandIcon={<ExpandMoreIcon />}
                                            aria-controls="left-menu"
                                            id="left-menu">
                                            General
                                        </AccordionSummary> */}
                                         <AccordionSummary id="faq-category-general" aria-controls="faq-category-general-content">
                                        {active === "general" ?
                                        <Typography variant="h6" component="h3"
                                            onClick={() => setActive("general")}
                                            sx={{color:"#0057A3 !important"}}
                                            id="left-menu-general-active">
                                            General
                                        </Typography>
                                        :
                                        <Typography variant="h6" component="h3"
                                            onClick={() => setActive("general")}
                                            sx={{color:"#000000 !important"}}
                                            id="left-menu-general-inactive">
                                            General
                                        </Typography>
                                        }
                                        </AccordionSummary>

                                        {/* <AccordionDetails>
                                            <List>
                                                <ListItem>
                                                    About
                                                </ListItem>
                                                <ListItem>
                                                    Login
                                                </ListItem>
                                                <ListItem>
                                                    Maintain Profile
                                                </ListItem>
                                            </List>
                                        </AccordionDetails> */}
                                    </Accordion>


                                    <Accordion>
                                    <AccordionSummary id="faq-category-idp" aria-controls="faq-category-idp-content">
                                    {active === "idp" ?

                                        <Typography variant="h6" component="h3"
                                            onClick={() => setActive("idp")}
                                            sx={{color:"#0057A3 !important"}}
                                            id="left-menu-idp-active">
                                            Industry Digital Plan (IDP)
                                        </Typography>
                                        :
                                        <Typography variant="h6" component="h3"
                                            onClick={() => setActive("idp")}
                                            sx={{color:"#000000 !important"}}
                                            id="left-menu-idp-inactive">
                                            Industry Digital Plan (IDP)
                                        </Typography>
                                        }
                                        </AccordionSummary>
                                        {/* <AccordionSummary expandIcon={<ExpandMoreIcon />}
                                            aria-controls="left-menu"
                                            id="left-menu">
                                            Industry Digital Plan (IDP)
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <List>
                                                <ListItem>
                                                    About
                                                </ListItem>
                                                <ListItem>
                                                    Login
                                                </ListItem>
                                                <ListItem>
                                                    Maintain Profile
                                                </ListItem>
                                            </List>
                                        </AccordionDetails> */}
                                    </Accordion>
                                    <Accordion >
                                        {/* <AccordionSummary expandIcon={<ExpandMoreIcon />}
                                            aria-controls="left-menu"
                                            id="left-menu">
                                            Withholding Tax (WHT) Exemption
                                        </AccordionSummary> */}

                                    <AccordionSummary id="faq-category-wht" aria-controls="faq-category-wht-content">
                                        {active === "wht" ?
                                        <Typography variant="h6" component="h3"
                                            onClick={() => setActive("wht")}
                                            sx={{color:"#0057A3 !important"}}
                                            id="left-menu-wht-active">
                                            Withholding Tax (WHT) Exemption
                                        </Typography>
                                        :
                                        <Typography variant="h6" component="h3"
                                            onClick={() => setActive("wht")}
                                            sx={{color:"#000000 !important"}}
                                            id="left-menu-wht-inactive">
                                            Withholding Tax (WHT) Exemption
                                        </Typography>
                                        }
                                    </AccordionSummary>

                                        {/* <AccordionDetails>
                                            <List>
                                                <ListItem>
                                                    About
                                                </ListItem>
                                                <ListItem>
                                                    Login
                                                </ListItem>
                                                <ListItem>
                                                    Maintain Profile
                                                </ListItem>
                                            </List>
                                        </AccordionDetails> */}
                                    </Accordion>


                                    <Accordion defaultExpanded={true}>
                                    <AccordionSummary id="faq-category-msi" aria-controls="faq-category-msi-content">
                                    {active === "msi" ?
                                    <Typography variant="h6" component="h3"
                                        onClick={() => setActive("msi")}
                                        sx={{color:"#0057A3 !important"}}
                                        id="left-menu-msi-active">

                                    Maritime Sector Incentive (MSI)
                                    </Typography>
                                    :
                                    <Typography variant="h6" component="h3"
                                        onClick={() => setActive("msi")}
                                        sx={{color:"#000000 !important"}}
                                        id="left-menu-msi-inactive">

                                    Maritime Sector Incentive (MSI)
                                    </Typography>

                                    }
                                     </AccordionSummary>

                                        {/* <AccordionSummary expandIcon={<ExpandMoreIcon />}
                                            aria-controls="left-menu"
                                            id="left-menu">
                                            Maritime Sector Incentive (MSI)
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <List>
                                                <ListItem>
                                                    About
                                                </ListItem>
                                                <ListItem>
                                                    Login
                                                </ListItem>
                                                <ListItem>
                                                    Maintain Profile
                                                </ListItem>
                                            </List>
                                        </AccordionDetails> */}
                                    </Accordion>

                                    {/* this div keeps the MSI accordion as "not(:last-child)"" so its divider border shows*/}
                                    <div />
                                </Grid>


                                <Grid item xs={useMediaQuery('(min-width: 900px)') ? 9 : 12}>

                            {function () {
                                switch (active) {
                                    case "msi": return <MSIPage />;
                                    case "idp": return <IDPPage />;
                                    case "wht": return <WHTPage/> ;
                                    case "general": return <GeneralPage/>;
                                    default: return <MSIPage />;
                                }
                            }()}

                                </Grid>
                            </Grid>
                        </Paper>
                    </Container>
                </div>
            </div>
        </div>
    </>)
}
